// List of supported mime types
export const AUDIO_MIME_TYPES = [
  // WAV format (most reliable for duration)
  { mimeType: "audio/wav", extension: "wav" },

  // MP4 formats (Safari, iOS) - better duration support
  { mimeType: "audio/mp4", extension: "m4a" },

  // OGG format (Firefox) - better than WebM for duration
  { mimeType: "audio/ogg;codecs=opus", extension: "ogg" },
  { mimeType: "audio/ogg;codecs=vorbis", extension: "ogg" },
  { mimeType: "audio/ogg", extension: "ogg" },

  // WebM formats (most widely supported but duration issues)
  { mimeType: "audio/webm;codecs=opus", extension: "webm" },
  { mimeType: "audio/webm;codecs=vorbis", extension: "webm" },
  { mimeType: "audio/webm", extension: "webm" },
];
